












































































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Dialog, Field, Toast } from "vant";
import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
import customField from "@/components/customField/index.vue";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
// import VerifyPasswordDialog from "@/components/VerifyPasswordDialog.vue";

import amountDisplay from "@/mixins/amountDisplay";

@Component({
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    CustomSelect,
    [customField.name]: customField,
    passwordErrorPrompt,
    // VerifyPasswordDialog
  },
  mixins: [amountDisplay],
  filters: {
    filterAmount(val) {
      if (val === undefined) {
        return "--";
      } else if (val === null) {
        return "0.00";
      } else {
        return val;
      }
    }
  }
})
export default class Withdraw extends Vue {
  showNoBankCardDialog = false;
  showVerifyPasswordDialog = false;
  qh: any = {}; //A账户信息
  lx: any = {}; // B账户信息
  form = {
    remittance_currency: "USD",
    remittance_bank_id: "",
    amount: ""
  };
  accountType:any = null;

  bankCardColumns = [];
  Trpassword:any = null;

  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ''
  }

  amountIsAll = false;

  // 是否显示全部余额
  // 对应币种可转出金额 大于0 支持全部余额标签
  get isShowAllAmount(){
    const { remittance_currency } = this.form;
    const obj = {
      USD: "usd_can_draw",
      HKD: "hkd_can_draw",
      CNH: "cnh_can_draw"
    };
    return this.qh[obj[remittance_currency]] > 0;
  }

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }
  get bgColorDialog(){
    return this.bgColor == 'black-theme' ? 'black-theme-dialog' : ''
  }

  get currencyColumns() {
    const { account_type } = this.$route.query;
    return [
      {
        text: this.$t("withdraw.usd"),
        value: "USD"
      },
      {
        text: this.$t("withdraw.hkd"),
        value: "HKD"
      },
      {
        text: this.$t("withdraw.rmb"),
        value: "CNH"
      }
    ];
  }

  get accountName() {
    if (this.$route.query.account_type == "2") {
      return this.$t("funds.accountName[1]");
    } else {
      return this.$t("funds.accountName[0]");
    }
  }

  get isSubmitDisabled() {
    return Object.keys(this.form).some(key => {
      return !this.form[key];
    });
  }

  get amountLimit() {
    const map = {
      USD: "usd_can_draw",
      HKD: "hkd_can_draw",
      cnh: "cnh_can_draw"
    };
    for (const key in map) {
      if (this.form.remittance_currency == key) {
        const item = map[key];
        return this.qh[item];
      }
    }
    return 0;
  }

  get transferableBalance() {
    const { account_type } = this.$route.query;
    return this.filterAmount(this.qh.base_can_draw)
  }

  created() {
	this.accountType = (this as any).$route.query.account_type
    this.getAccountBalanceDetails();

    (this as any).$apis
      .getBankList("", {
        customLoading: true
      })
      .then(res => {
        if (res.length) {
          this.bankCardColumns = res.map(item => {
            return {
              text: `${item.bank_name} ${item.secret_card}`,
              value: item.id
            };
          });
        } else {
          this.showNoBankCardDialog = true;
        }
      })
      .catch(e => {
        
      });
  }

  filterAmount(val) {
    if (val === undefined) {
      return "--";
    } else if (val === null) {
      return "0.00";
    } else {
      return val;
    }
  }

  getAccountBalanceDetails() {
    const { account_type, account_no } = this.$route.query;
    const params = {
      type:account_type,
      account_no: account_no || ""
    };
    (this as any).$apis
      .getAccountBalanceDetails(params, { customLoading: true })
      .then(res => {
        const { qh, lx } = res;
        this.qh = qh;
        this.lx = qh;
      })
      .catch(e => {
        
      });
  }

  formatterAmount(value) {
    if(!this.amountIsAll){
      value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      value = value.replace(/^\./g, ""); //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    }
    return value;
  }

  handleNextStep() {
    // if (this.form.amount > this.amountLimit) {
    //   return Toast(this.$t("common.amount_verify_fail_text"));
    // }
	this.showVerifyPasswordDialog = true;
	// if(this.$route.query.type != "2"){
	// }else{
	//    this.handleAfterVerifySuccess();
	// }
  }

  handleAfterVerifySuccess() {
    this.showVerifyPasswordDialog = false;
    const funds_account_type = this.$route.query.account_type;
    const account_no = this.$route.query.account_no;
	(this as any).$apis
	  .checkPasswordFail({
	    password: this.Trpassword
	  })
	  .then((res) => {
      // TODO: 资金转出-登录错误 Code 100173
      // TODO: 资金转出-登录错误，冻结 Code 100174
      if(res.code){
        if( res.code === 100174 || res.code === 100173 ){
          this.pwdErrPromptOption.errCode = res.code;
          this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
          this.pwdErrPromptOption.show = true;
          (this as any).$refs['password-error-prompt-el'].show = true;
          return
        }
      }
      let params = {
        ...this.form,
        funds_account_type,
        account_no,
        is_all: this.amountIsAll ? 1 : 0
      };
      if(this.amountIsAll){
        (params as any).amount = 0;
      }
		  (this as any).$apis
		    .postWithdrawOrder(params)
		    .then(() => {
		      Dialog.alert({
		        ["title" as any]: this.$t("withdraw.withdraw_success_title"),
		        ["message" as any]: this.$t("withdraw.withdraw_success_msg"),
		        ["confirmButtonText" as any]: this.$t("common.ok"),
		        ["className" as any]: this.bgColor == 'black-theme' ? 'black-theme-dialog' : ''
		      })
		        .then(() => {
		          this.$router.go(-1);
		        })
		        .catch(() => {
		          // on cancel
		        });
		    })
		    .catch(e => {
		      
		    });
	  }).catch(e => {
	    
	  });

  }

  passwordErrorPromptConfirm(errCode){
    (this as any).pwdErrPromptOption.show = false;
    if(errCode === 100173){
      (this as any).Trpassword = '';
      (this as any).showVerifyPasswordDialog = true;
      (this as any).$refs['custom-field-password'].setInputFocus();
	  setTimeout(() =>{
		 (this as any).$refs['custom-field-password'].setInputFocus();
	  },500)

    }
  }

  /**
   * @Description 保留原先业务逻辑，增加千分位显示
   * @date 2024/2/4
   * @param {any} num
   * @return {string}
   */
  amountDisplay(num) {
    if (num === undefined || num === null) {
      // 保留原先业务逻辑
      return (this as any).filterAmount(num);
    } else {
      if (!isNaN(num)) {
        return (this as any).mixinAmountDisplay(num);
      } else {
        // 保留原先业务逻辑
        // num存在传入“--”的情况
        return num
      }
    }
  }

  // 全部金额
  setAmountIsAll(){
    this.amountIsAll = !this.amountIsAll;
    (this as any).form.amount = this.amountIsAll ? (this as any).$t("withdraw.all_amount") : "";
  }

  clearAmount(){
    this.amountIsAll = false;
  }
}
